import { useQuery } from 'react-query';
import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';

export type OpenableOrderKind = 'order' | 'thunderbird-order';

// Looks an order up by its PID so a link like /?order=1048 (or ?tb=TB-2026-SEP-006) can reopen
// the panel after a refresh. Resolves to the list item the row click would have passed along.
export default function useOrderByPid(
  pid: string | null | undefined,
  kind: OpenableOrderKind = 'order',
) {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<any | null>(
    ['order-by-pid', kind, pid],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const url =
        kind === 'thunderbird-order' ? 'api/thunderbird-orders' : 'api/orders';
      const params: Record<string, unknown> = { page: 1, pageSize: 50, pid };
      if (kind === 'order') params.section = 'Search';
      const response = await api.get<any>(url, { params });
      if (response.status !== 200) throw new Error('Order not found');
      const items: any[] = response.data?.items || [];
      return (
        items.find(
          (item) =>
            String(item.pid).toLowerCase() === String(pid).toLowerCase(),
        ) || null
      );
    },
    { enabled: !!pid, retry: false, refetchOnWindowFocus: false },
  );
}
